const copyText = async (text) => {
    if (navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(text);
        return;
    }

    const input = document.createElement('textarea');
    input.value = text;
    input.setAttribute('readonly', '');
    input.style.position = 'fixed';
    input.style.opacity = '0';
    document.body.append(input);
    input.select();
    document.execCommand('copy');
    input.remove();
};

export default function copyLink() {
    const buttons = [...document.querySelectorAll('[data-copy-link]')];

    buttons.forEach((button) => {
        button.addEventListener('click', async () => {
            const label = button.querySelector('[data-copy-link-label]');

            try {
                await copyText(window.location.href);
                if (label) {
                    label.textContent = 'Copied';
                }
                button.classList.add('is-copied');
                window.setTimeout(() => {
                    if (label) {
                        label.textContent = 'Copy link';
                    }
                    button.classList.remove('is-copied');
                }, 1800);
            } catch (error) {
                if (label) {
                    label.textContent = 'Copy failed';
                }
            }
        });
    });
}
